import { Card } from "@/components/ui/card";

interface MetricCardProps {
  title: string;
  score: number;
  description: string;
}

export const MetricCard = ({ title, score, description }: MetricCardProps) => {
  return (
    <Card className="p-6 hover:shadow-md transition-all duration-300 bg-card border-opacity-50">
      <h3 className="font-semibold mb-3 text-lg text-foreground">{title}</h3>
      <div className="flex items-center gap-3 mb-3">
        <div className="text-3xl font-bold text-primary">
          {score}/10
        </div>
        <div className="h-2.5 flex-1 bg-secondary rounded-full overflow-hidden">
          <div 
            className="h-full bg-primary transition-all duration-500 rounded-full"
            style={{ width: `${score * 10}%` }}
          />
        </div>
      </div>
      <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
    </Card>
  );
};